import React from 'react';
import cn from 'clsx';
import Typography from './Typography';
import IconCheckLight from '../icons/icon-checklight-24.svg';
import IconClose from '../icons/icon_close_24.svg';
import styles from './PricingComparsionTable.module.scss';
import {Button} from './ui/button';

const PricingComparisonTable = ({plans, table, onSelect}) => {
    return (
        <div className={cn(styles["pricing-comparison-table"], "table-responsive")}>
            <table className="table">
                <thead>
                <tr>
                    <th>
                        <Typography text={<>
                            Our
                            <br/>
                            plans
                        </>} fontSize={3} fontWeight="bold" />
                    </th>
                    {
                        plans.map((p,idx) => {
                            return (
                                <th key={idx} className={cn(styles['pricing-comparison-table__cell'], {
                                    [styles['pricing-comparison-table__cell--featured']]: p.featured,
                                })}>
                                    <div>{p.title}</div>
                                    <div className={styles["pricing-comparison-table__price-info"]}>
                                        <div className={styles["pricing-comparison-table__price-text"]}>
                                            <span>{p.price}</span>
                                            <span className={styles["pricing-comparison-table__currency"]}>{p.currency}</span>
                                            <span className={styles["pricing-comparison-table__duration"]}>month</span>
                                        </div>
                                    </div>
                                </th>
                            )
                        })
                    }
                </tr>
                </thead>
                <tbody>
                {table.map(category => {
                    return (
                        <React.Fragment key={category.category_title}>
                            <tr>
                                <th>{category.category_title}</th>
                                <th />
                                <th />
                                <th />
                            </tr>
                            {category.features.map((f,index) => {
                                return (
                                    <tr key={f.label} className={cn(styles['pricing-comparison-table__row'], {
                                        [styles['pricing-comparison-table__row--striped']]: index % 2 === 0,
                                    })}>
                                        <td>{f.label}</td>
                                        {f.packages_configuration.map((packageConfig, packageIndex) => {
                                            return (
                                                <td key={packageIndex} className={cn(styles['pricing-comparison-table__cell'], {
                                                    [styles['pricing-comparison-table__cell--highlighted']]: !!packageConfig.enabled,
                                                })}>
                                                    {packageConfig.description ? packageConfig.description : packageConfig.enabled ? <IconCheckLight /> : <IconClose />}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </React.Fragment>
                    )
                })}
                </tbody>
                <tfoot>
                <tr>
                    <th />
                    {
                        plans.map((p,idx) => {
                            return (
                                <td key={idx}>
                                    {!p.active || p.isTrialSubscriptionActive ? (
                                        <Button
                                            size="sm"
                                            variant={p.featured ? "default" : "outline"}
                                            onClick={() => {
                                                onSelect(p)
                                            }}
                                        >
                                            {p.hasActiveSubscription && !p.isTrialSubscriptionActive ? 'Switch plan' : `Choose ${p.title}`}
                                        </Button>
                                    ) : null}
                                </td>
                            )
                        })
                    }
                </tr>
                </tfoot>
            </table>
        </div>
    )
};


export default PricingComparisonTable;
